import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Navigator from '../Navigator'

import '../../styles/ModalMenuItem.css'

class ModalMenuItem extends Component {
  render () {
    const {
      data
    } = this.props

    const {
      menuableType,
      menuableId,
      titleOverride,
      item
    } = data

    const title = titleOverride || item.title

    return (
      <Navigator history={this.props.history} type={menuableType} id={menuableId}>
        <div className='card'>
          <div className='card-content'>{title}</div>
          <div className='card-link'><img src='/images/inline/arrow.png' alt='' /> See More Info</div>
          <div className='overlay primary-1' />
        </div>
      </Navigator>
    )
  }
}

ModalMenuItem.propTypes = {
  data: PropTypes.object,
  history: PropTypes.object
}

export default ModalMenuItem



// WEBPACK FOOTER //
// ./src/components/menus/ModalMenuItem.js